var _style, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:currentColor;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,20.2c-0.1,0-0.3-0.1-0.4-0.2l-3.1-3.1L8.3,17c-0.5,0.1-0.9,0.2-1.3,0.2c-3.1,0-5.7-2.5-5.7-5.7 c0-0.7,0.2-1.4,0.5-2.3C1.9,9,2.1,8.9,2.3,8.9c0.1,0,0.2,0,0.3,0C2.9,9.1,3,9.4,2.9,9.7c-0.2,0.6-0.3,1.1-0.3,1.8 c0,2.4,2,4.4,4.4,4.4s4.4-2,4.4-4.4S9.4,7.1,7,7.1S2.4,6.4,0.6,5l0,0l0,0C0.4,4.8,0.3,4.7,0.3,4.6c0-0.2,0-0.4,0.1-0.5l0,0l0,0 c0.1-0.2,0.3-0.2,0.4-0.2s0.3,0,0.4,0.1C2.8,5.2,4.8,5.8,7,5.8c1.9,0,3.6,0.9,4.7,2.6L12,8.9l0.3-0.5c1.1-1.6,2.8-2.6,4.7-2.6 c2.2,0,4.1-0.7,5.7-1.9c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.5c0,0.2-0.1,0.3-0.2,0.4 C21.6,6.3,19.4,7,17,7s-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4c0-0.6-0.1-1.2-0.3-1.8c-0.1-0.3,0-0.7,0.3-0.8c0.1,0,0.2,0,0.3,0 c0.2,0,0.5,0.1,0.5,0.3c0.3,0.9,0.5,1.6,0.5,2.3c0,3.1-2.5,5.7-5.7,5.7c-0.4,0-0.8-0.1-1.3-0.2l-0.2-0.1l-3,3.2 C12.3,20.2,12.2,20.2,12,20.2z M11.7,14.7c-0.4,0.6-0.9,1.1-1.5,1.5l-0.4,0.3l2.2,2.2l2.2-2.2l-0.4-0.3c-0.6-0.4-1.1-0.9-1.5-1.5 L12,14.2L11.7,14.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,9.6c-1,0-1.9,0.8-1.9,1.9s0.8,1.9,1.9,1.9s1.9-0.8,1.9-1.9S8,9.6,7,9.6z M7.5,11.4c-0.3,0-0.6-0.3-0.6-0.6 s0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6S7.8,11.4,7.5,11.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,9.6c-1,0-1.9,0.8-1.9,1.9s0.8,1.9,1.9,1.9s1.9-0.8,1.9-1.9S18.1,9.6,17.1,9.6z M16.6,11.4 c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6S16.9,11.4,16.6,11.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.2e0ec6406814048f361af3f16b60f0e4.svg";
export { ForwardRef as ReactComponent };